import { useQuery } from "react-query";
import { storeLocalData, getLocalData } from "../services/storage";
import useNetworkHealth from "./useNetworkHealth";
import openhouseAPI from "../services/openhouse";

const normalizeQuestions = (payload: any) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const useGetFormQuestions = (
  uuid: string | undefined,
  noAuth: boolean
) => {
  const network = useNetworkHealth();

  const { isFetching, isFetched, data, error, refetch } = useQuery(
    ["formQuestions", uuid, network.status],
    async () => {
      if (!uuid) return [];

      const localQuestions = await getLocalData(`@formQuestions+${uuid}`);
      const normalizedLocalQuestions = normalizeQuestions(localQuestions);

      if (normalizedLocalQuestions.length > 0) {
        return normalizedLocalQuestions;
      }

      if (network.isOffline) {
        return normalizedLocalQuestions;
      }

      try {
        const res = await openhouseAPI.get(`/form/questions/${uuid}`);
        const normalizedQuestions = normalizeQuestions(res.data);
        await storeLocalData(`@formQuestions+${uuid}`, normalizedQuestions);
        return normalizedQuestions;
      } catch (error) {
        console.error("Error fetching form questions:", error);
        return normalizedLocalQuestions;
      }
    },
    {
      staleTime: 30000,
      cacheTime: 30000,
      enabled: !!uuid,
    }
  );

  return {
    isFetching,
    isFetched,
    data,
    error,
    refetch,
  };
};
